import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ParamHistorical } from '../../../../../shared/types/param';
import { FormikProps } from 'formik';
import { FUNCTIONARIES_SWITCHBOARD } from '../../../../../routes/paths';
import { asyncGetParams } from '../../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { FunctionariesSwitch } from '../../../../../shared/types/systemConfiguration/functionariesSwitch';
import {
    asyncCreateFunctionariesSwitch,
    asyncGetFunctionariesSwitch,
    asyncGetFunctionariesSwitchHistorical,
    asyncUpdateFunctionariesSwitch,
} from '../../../../../services/functionaries-switch.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';

export const useFunctionariesSwitchForm = () => {
    const navigate = useNavigate();
    const { idFunctionariesSwitch } = useParams();
    const [areaOptions, setAreaOptions] = useState<ISelect[]>([]);
    const [positionOptions, setPositionOptions] = useState<ISelect[]>([]);
    const [functionarieSwitch, setFunctionariesSwitch] =
        useState<FunctionariesSwitch>();
    const [loading, setLoading] = useState(false);
    const [formikFunctionariesSwitchData, setFormikFunctionariesSwitchData] =
        useState<FormikProps<FunctionariesSwitch>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [functionariesSwitchHistorical, setFunctionariesSwitchHistorical] =
        useState<ParamHistorical[]>();

    const isValidForm = formikFunctionariesSwitchData?.isValid;

    const handleCleanAndBack = () => {
        formikFunctionariesSwitchData?.resetForm();
        navigate(FUNCTIONARIES_SWITCHBOARD);
    };

    const handleSubmit = async () => {
        await formikFunctionariesSwitchData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: FunctionariesSwitch = formikFunctionariesSwitchData?.values;

        let res: any | undefined = undefined;

        try {
            if (functionarieSwitch && functionarieSwitch.id) {
                res = await asyncUpdateFunctionariesSwitch(
                    functionarieSwitch.id,
                    data
                );
            } else {
                res = await asyncCreateFunctionariesSwitch(data);
            }
        } catch (error) {
            console.error(error);
        }

        if (res) {
            ToastSwal.fire({
                text: `¡Felicidades! el funcionario se ${
                    functionarieSwitch && functionarieSwitch.id
                        ? 'actualizó'
                        : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${FUNCTIONARIES_SWITCHBOARD}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    functionarieSwitch && functionarieSwitch.id
                        ? 'actualizar'
                        : 'crear'
                } el Funcionario para Conmutador. Por favor, asegúrate de ${
                    functionarieSwitch && functionarieSwitch.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        asyncGetParams(ParamEnum.FUNCTIONARIES_SWITCHBOARD_AREA).then((items) =>
            setAreaOptions(items)
        );

        asyncGetParams(ParamEnum.FUNCTIONARIES_SWITCHBOARD_POSITION).then(
            (items) => setPositionOptions(items)
        );
    }, []);

    useEffect(() => {
        if (Boolean(idFunctionariesSwitch)) {
            setLoading(true);
            asyncGetFunctionariesSwitch(idFunctionariesSwitch)
                .then((functionariesSwitch: any) => {
                    if (!functionariesSwitch)
                        navigate(FUNCTIONARIES_SWITCHBOARD);
                    setFunctionariesSwitch(functionariesSwitch);
                })
                .finally(() => setLoading(false));
        }
    }, [idFunctionariesSwitch]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            console.log('get history');
            asyncGetFunctionariesSwitchHistorical(idFunctionariesSwitch)
                .then((resp) => {
                    if (resp) setFunctionariesSwitchHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        functionarieSwitch,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikFunctionariesSwitchData,
        functionariesSwitchHistorical,
        showHistorical,
        setShowHistorical,
        areaOptions,
        positionOptions,
    };
};
